import { Component, Input } from "@angular/core";
import { TypeText } from "../../ui-dto/text/type-text";
import { CheckUtils } from "../../ui-utils/check-utils";
var HTML_TEMPLATE = "\n<div class=\"od-textfield\">\n\t<div [class]=\"'od-textfield-icon ' + iconName\"></div>\n\t<input class=\"od-textfield-input\" [required]=\"required\" [placeholder]=\"getValue(placeholder)\" [(ngModel)]=\"value\"\n\t[ngClass]=\"{'od-textfield-space-icon': iconName!=null}\"\n\t[attr.type]=\"type\" \n\t[attr.autocomplete]=\"autocomplete\"\n\t[attr.disabled]=\"disabled == true ? true : null\">\n</div>\n";
var CSS_STYLE = "\n.od-textfield{\n\tposition: relative;\n}\n.od-textfield:hover {\n    border-color: #e7e9ee;\n    box-shadow: 0 0 7px 0 rgba(68,170,214,0.4);\n}\n\n.od-textfield:focus {\n    box-shadow: none;\n    border-color: #25aed8;\n}\n\n.od-textfield-icon:before {\n    position: absolute;\n    left: 12px;\n    top: 10px;\n    color: #b7c0cd;\n    font-weight: normal;\n    font-size: 16px;\n    background-color: white;\n    padding-right: 8px;\n}\n\n.od-textfield-space-icon{\n    text-indent: 28px;\n}\n\n.od-textfield-input{\n\tborder: 1px solid #dfe1ea;\n    outline-width: 0;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 600;\n    box-sizing: border-box;\n    transition: all .15s linear;\n    width: 100%;\n    padding: 0 12px;\n    height: 36px;\n    font-family: 'Lato',sans-serif;\n}\n\n.od-textfield-input:focus {\n    box-shadow: none;\n    border-color: #25aed8;\n}\n.od-textfield-input:hover {\n    border-color: #e7e9ee;\n    box-shadow: 0 0 7px 0 rgba(68,170,214,0.4);\n}\n.od-textfield-input:disabled{\n\tborder-color: #e7e9ee;\n    color: #939aa3;\n    background-color: #f8f9fb;\n}\n";
var Textfield = /** @class */ (function () {
    function Textfield() {
        this.value = "";
        this.type = TypeText.TEXT;
    }
    Textfield.prototype.clear = function () {
        this.value = "";
    };
    Textfield.prototype.getValue = function (value) {
        return CheckUtils.isEmpty(value) ? "" : value;
    };
    Textfield.decorators = [
        { type: Component, args: [{
                    selector: "od-textfield",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Textfield.ctorParameters = function () { return []; };
    Textfield.propDecorators = {
        "type": [{ type: Input },],
        "required": [{ type: Input },],
        "value": [{ type: Input },],
        "placeholder": [{ type: Input },],
        "iconName": [{ type: Input },],
        "autocomplete": [{ type: Input },],
        "disabled": [{ type: Input },],
        "active": [{ type: Input },],
    };
    return Textfield;
}());
export { Textfield };
//# sourceMappingURL=textfield.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/text/textfield.js
// module id = 418
// module chunks = 14